export const PAYMENT_TYPES: { [x: string]: string } = {
  CASH: 'Наличные',
  NON_CASH: 'Безналичный',
}

export const CURRENCY_CODES: Record<number, string> = {
  933: 'BYN',
  840: 'USD',
  978: 'EUR',
  643: 'RUB',
}

export const SCENARIO_TITLES: Record<string, string> = {
  CLIENT_SALE_BY_OWNER: 'Оформление заказа для клиента',
  PROCUREMENT: 'Оформление заказа на закупку',
  PARTNER_SALE: 'Оформление заказа для партнера',
  CLIENT_SELF_SERVICE: 'Оформление заказа',
}

export const SCENARIOS = {
  CLIENT_SELECTION_PENDING: 'CLIENT_SELECTION_PENDING',
  PROCUREMENT: 'PROCUREMENT',
  CLIENT_SALE_BY_OWNER: 'CLIENT_SALE_BY_OWNER',
  PARTNER_SALE: 'PARTNER_SALE',
  CLIENT_SELF_SERVICE: 'CLIENT_SELF_SERVICE',
} as const

export const SCENARIO_LABELS = {
  CLIENT_SELECTION_PENDING: 'Ожидание выбора клиента',
  PROCUREMENT: 'Закупка',
  CLIENT_SALE_BY_OWNER: 'Продажа клиенту',
  PARTNER_SALE: 'Продажа партнеру',
  CLIENT_SELF_SERVICE: 'Самообслуживание',
} as const

export const SCENARIO_MESSAGES = {
  CLIENT_SELECTION_PENDING: 'Клиент не выбран',
  PROCUREMENT: 'Режим: Закупка',
  CLIENT_SALE_BY_OWNER: 'Продажа клиенту',
  PARTNER_SALE: 'Продажа партнеру',
  CLIENT_SELF_SERVICE: '',
} as const

export const DEFAULT_CURRENCY = 933

export const DEFAULT_REGION_BANK_HEADER_VALUE = 'NBRB'

export const ORDER_STATUSES: { [x: string]: string } = {
  NEW_BY_CLIENT: 'Новый (от клиента)',
  SUBMITTED_BY_CLIENT: 'Подтвержден клиентом',
  NEW: 'Новый',
  IN_WORK: 'В работе',
  PENDING_TO_SUPPLIER: 'Ожидает отправки поставщику',
  QUEUED_TO_SUPPLIER: 'В очереди к поставщику',
  BROKER_SENT: 'Отправлен в обработку',
  BROKER_FAILED: 'Ошибка отправки в обработку',
  REPLICATED_ON_SUPPLIER: 'Принят поставщиком',
  DLQ: 'Ошибка обработки (DLQ)',
  PROCESSING_SUB_ORDERS: 'Обработка под-заказов',
  CLOSED: 'Закрыт',
  CANCELED: 'Отменен',
}

const HIDDEN_ORDER_STATUSES_IN_SELECT = new Set([
  'NEW_BY_CLIENT',
  'BROKER_SENT',
  'BROKER_FAILED',
  'PROCESSING_SUB_ORDERS',
  'QUEUED_TO_SUPPLIER',
  'DLQ',
])

export const ORDER_STATUSES_IN_SELECT = Object.fromEntries(
  Object.entries(ORDER_STATUSES).filter(
    ([status]) => !HIDDEN_ORDER_STATUSES_IN_SELECT.has(status)
  )
)

export const ORDER_PRODUCT_STATUSES: { [x: string]: string } = {
  UNRECOGNIZED: 'Неопознан',
  NEW: 'Новый',
  SUBMITTED_BY_CLIENT: 'Подтвержден клиентом',
  IN_WORK: 'В работе',
  ON_THE_WAY: 'В пути',
  READY_FOR_PICKUP: 'Готов к выдаче',
  SENT: 'Отправлен',
  RECEIVED: 'Получен',
  REJECTED: 'Отклонен',
  SYNC_ERROR: 'Ошибка синхронизации',
  CLOSED: 'Закрыт',
}
